import { useContext } from "react";
import axios from "axios";

import AuthContext from "common/store/AuthContext";
import { MapSettings } from "common/types/MapSettings";
import { getServerUrl } from "utils/commonTools";
import { MapArea } from "common/types/MapArea";
import { PolygonArea } from "common/components/map/common/types/MapData";

export const useMap = () => {
  const { token } = useContext(AuthContext);

  const getInitialPosition = async (parkId: number) => {
    const config = {
      headers: { "Content-type": "application/json", Authorization: `Bearer ${token}` },
    };

    try {
      const { data } = await axios.get<MapSettings>(
        getServerUrl() + `map/settings/${parkId}`,
        config,
      );
      return data;
    } catch (error) {
      console.log("地図の設定情報の取得エラー", error);
      return undefined;
    }
  };

  const buildAreaPolygons = (areas: MapArea[]): PolygonArea[] => {
    return areas.flatMap((area) =>
      area.polygon ? [{ ...area.polygon, label: area.area.name }] : [],
    );
  };

  return { getInitialPosition, buildAreaPolygons };
};
